import React, { useEffect, useState } from 'react'
import { uid } from '@zera-admin/utils'
import Breadcrumb, { BreadcrumbItem } from '@zera-admin/breadcrumb'
import Button, { ButtonGroup, LinkButton } from '@zera-admin/button'
import Page, { PageHeader, Container } from '@zera-admin/page'

import { useFlagcardContext } from 'app/contexts/flagcard'
import { ValidationError } from 'app/shared/types'
import MainLayout from 'layouts/main'
import entityCategoryTypeService, {
  EntityCategoryType,
  UpdateEntityCategoryTypeRequest,
} from 'services/http/dataset/entity-category-type'

import { UpdateEntityCategoryTypeProps } from './types'
import EntityCategoryTypeForm from './EntityCategoryTypeForm'

const UpdateEntityCategoryType: React.FunctionComponent<UpdateEntityCategoryTypeProps> =
  ({ match, history }) => {
    const [isLoading, setIsLoading] = useState(false)
    const [isReady, setIsReady] = useState(true)
    const [categoryType, setCategoryType] = useState<EntityCategoryType>()
    const [flagcard] = useFlagcardContext()

    useEffect(() => {
      const id = parseInt(match.params.id)

      entityCategoryTypeService
        .getById(id)
        .then((res) => {
          setCategoryType(res.data)
        })
        .catch((err: Error) => {
          console.log(err)
        })
        .finally(() => {
          setIsReady(false)
        })
    }, [match.params.id, history])

    const handleSubmit = (data: UpdateEntityCategoryTypeRequest) => {
      if (data) {
        setIsLoading(true)

        entityCategoryTypeService
          .update(data)
          .then(() => {
            flagcard.add({
              id: uid(),
              appearance: 'success',
              title: 'İşlem Başarılı',
              children:
                'Geçerli veri, sistem üzerinde başarıyla güncellenmiştir.',
            })
          })
          .catch((error) => {
            console.log(error)

            flagcard.add({
              id: uid(),
              appearance: 'error',
              title: 'Hata Oluştu',
              children:
                'Geçerli veri güncellenirken bir hata oluştu. Lütfen tekrar deneyin. Sorununuz düzelmediyse servis sağlayıcısı ile iletişime geçiniz.',
            })
          })
          .finally(() => {
            setIsLoading(false)
          })
      }
    }

    const handleError = (error?: ValidationError) => {
      console.log(error)
    }

    const breadcrumbs = (
      <Breadcrumb>
        <BreadcrumbItem text="Anasayfa" href="/" />
        <BreadcrumbItem
          text="Varlık kategorisi türü"
          href="/entity-category-type"
        />
        <BreadcrumbItem text="Varlık kategorisi türü güncelle" />
      </Breadcrumb>
    )

    return (
      <MainLayout isLoading={isReady}>
        <Container width="medium">
          <Page>
            <PageHeader
              // actions={<Button appearance="error">Delete user</Button>}
              breadcrumbs={breadcrumbs}
              bottomBar={
                <p>
                  Aşağıdaki bilgileri doldurarak geçerli varlık kategorisi türü
                  bölümünü güncelleyebilirsiniz.
                </p>
              }
            >
              Veri güncelleniyor: {categoryType ? categoryType.name : null}
            </PageHeader>
            <EntityCategoryTypeForm
              actions={
                <ButtonGroup>
                  <Button
                    appearance="primary"
                    children="Güncelle"
                    isLoading={isLoading}
                    type="submit"
                  />
                  <LinkButton href="/entity-category-type">İptal</LinkButton>
                </ButtonGroup>
              }
              operation="update"
              onSubmit={handleSubmit}
              onError={handleError}
              values={categoryType}
            />
          </Page>
        </Container>
      </MainLayout>
    )
  }

export default UpdateEntityCategoryType
